import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=606c3848&scoped=true&"
import script from "./PaymentHistory.vue?vue&type=script&lang=js&"
export * from "./PaymentHistory.vue?vue&type=script&lang=js&"
import style0 from "./PaymentHistory.vue?vue&type=style&index=0&id=606c3848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c3848",
  null
  
)

component.options.__file = "PaymentHistory.vue"
export default component.exports